import React from 'react';
import { useTranslation } from 'react-i18next';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

export default function ExportExcel({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.CSV-TEXT.';
  return (
    <>
      <div className="form-element">
        {t(label + 'SOURCE')}
        <VariablePicker action={action} inputName="source" isRequired
          variables={variables} setOpenVariable={setOpenVariable} />
      </div>
      <div className="form-element">
        {t('CONTENT.CONFIGURATION-FORM.EXCEL.SAVE.FOLDER-PATH')}
        <TextInput action={action} inputName="folderPath" setOpenVariable={setOpenVariable}
          variables={variables} isRequired fieldType="string" displayName={t('CONTENT.CONFIGURATION-FORM.EXCEL.SAVE.FOLDER-PATH')}/>
        <small><em>e.g.    C:\Autommate\test</em></small>
      </div>
      <div className="form-element">
        {t(label + 'ASSIGN-VARIABLE')}
        <VariablePicker action={action} inputName="assignToVariable"
          variables={variables} setOpenVariable={setOpenVariable} isRequired />
      </div>
    </>
  );
}